import AF from '../utlis/AF';

const CLASS_ACTIVE = 'is-active';

export default class Nav {
  constructor() {
    this.el = document.querySelector('[nav]');

    this.af = AF.instance();
    this.activate = this.activate.bind(this);
    this.init();
  }

  init() {

  this.searchClose = document.querySelector('.menu-search__close');
  this.searchContainer = document.querySelector('.nav__search-container')
  this.searchBtn = document.querySelector('.nav__item--search')
  this.searchInput = this.el.querySelector('input')

  this.searchBtn.addEventListener('click', ()=>{
    this.searchContainer.classList.add('open')
    this.searchInput.focus()
  })

  this.searchClose.addEventListener('click', ()=>{
    this.searchContainer.classList.remove('open')
    this.searchInput.blur()
  })

    window.setTimeout(() => {
      this.af.onNextWrite(this.activate);
    }, 1000);
  }

  activate() {
    this.el.classList.add(CLASS_ACTIVE);
  }
}